import React, { useContext, useEffect, useState } from 'react';
import styles from './SearchBarButton.module.scss';
import { SearchIcon } from '../../icons/Icons';
import { AppContext } from '../../../context/AppContext';
import { useHistory, useLocation } from 'react-router-dom';
import { RouteWithState } from '../../../lib/util';
import { DirectoryListType } from '../../directory-list/DirectoryList';

const SearchBarButton = (props: any) => {
  const appContext = useContext(AppContext);
  const { chosenSpecialty, location, name, directoryListType, distance, isDisabled, shortPlanName, reportYear } = appContext;

  const [buttonClassName, setButtonClassName] = useState<string>(``);
  const history = useHistory();
  const locationHook = useLocation(); // ✅ moved inside

  useEffect(() => {
    const newClassName = `${styles.searchButton}${isDisabled ? ` ${styles.disabled}` : ''}`;
    setButtonClassName(newClassName);
  }, [isDisabled]);

  // 👇 Debug (SAFE now)
  useEffect(() => {
    const queryParams = new URLSearchParams(locationHook.search);
    const pcpFromUrl = queryParams.get('pcp');

    console.log('🔍 URL search string:', locationHook.search);
    console.log('🧪 Extracted PCP param:', pcpFromUrl);
  }, [locationHook.search]);

  const handleSearch = () => {
    if (!isDisabled) {
      const pcp = appContext.search?.pcp;

      const query = new URLSearchParams({
        distance: String(distance.distance),
      });

      if (pcp !== null && pcp !== undefined) {
        query.append('pcp', pcp);
      }

      if (directoryListType === DirectoryListType.pharmacy) {
  query.append('reportYear', String(reportYear));
}

      const path = RouteWithState(
        `/results/${shortPlanName}/${directoryListType}/${chosenSpecialty || 'undefined'}/${name || 'undefined'}/${location || 'undefined'}?${query.toString()}`,
        appContext
      );

      history.push(path);

      if (history.location.pathname.includes('/results')) {
        window.location.reload();
      }
    }
  };

  return (
    <div className={styles.searchButtonContainer}>
      <button className={buttonClassName} onClick={handleSearch}>
        <span className={`${styles.icon} ${styles.baseline}`}>
          <SearchIcon />
        </span>
        <span>Search</span>
      </button>
    </div>
  );
};

export default SearchBarButton;